import { GalleryController } from "../../../components/gallery/controller.js";
import { ModalController } from "../../../components/modal/controller.js";

export class UserPrivateProductView {
  constructor() {
    this.gallery = new GalleryController('app.userPrivateController.productos.view');
  }

  renderMain() {
    return `
      <div class="user-header">
        <h1>Mis productos</h1>
      </div>
      `;
  }

  renderForm(_data) {
    let isNew = false;
    if (!_data) {
      _data = {};
      isNew = true;
    }
    let html = `
    <div class="form">
      <input type="hidden" id="productos-idcod" value="${_data.idcod || ''}"> 
      <h2 class="mb0 ancho">Datos de mi producto</h2>
      <div class="group sb">
        <div class="group">
          <b>Categoría</b>
          <select id="productos-categoria" value="${_data.categoria || ''}"></select>
          <span id="productos-categoria-error"></span>
        </div>
        <div class="group">
          <b>Título</b>
          <input type="text" id="productos-titulo" value="${_data.titulo || ''}"> 
          <span id="productos-titulo-error"></span>
        </div>
        <div class="group">
          <b>Descripción corta</b>
          <textarea id="productos-resumen" rows="5">${_data.resumen || ''}</textarea> 
          <span id="productos-resumen-error"></span>
        </div>
      </div>
      <div class="group">
        <b>Imágenes</b>
        ${this.gallery.create(_data.imagenes)}
      </div>
      <div class="group">
        <b>Volumen</b>
        <div class="group vertical">
          <input id="productos-medida" type="number" value="${_data.medida || ''}" />
          <select id="productos-unidad" value="${_data.unidad || 0}"> </select>
        </div>
        <span id="productos-medida-error"></span>
        <span id="productos-unidad-error"></span>
      </div>
      ${app.userPrivateController.view.renderPriceOptions('productos', _data, isNew)}
      <div class="group">
        <b>Provincia</b>
        <select id="productos-provincia" value="${_data.provincia || ''}" onchange="
        APICRUD.Location.Selector_LoadCities('productos-localidad', this.value, '${_data.localidad}')
        "></select>
        <span id="productos-idState-error"></span>
      </div>
      <div class="group">
        <b>Localidad</b>
        <select id="productos-localidad" value="${_data.localidad || ''}"></select>
        <span id="productos-localidad-error"></span>
      </div>
      <div class="group">
        <b>Marca</b>
        <input type="text" id="productos-marca" value="${_data['marca'] || ''}"/>
        <span id="productos-marca-error"></span>
      </div>
      <div class="group">
        <b>Tipo de envíos</b>
        <select id="productos-tiene-envio" value="${_data['tiene-envio'] || 0}"> </select>
        <span id="productos-tiene-envio-error"></span>
      </div>
      <div class="group span">
        <b>Descripción completa del producto</b>
        <textarea id="productos-descripcion" rows="10">${_data.descripcion || ''}</textarea> 
        <span id="productos-descripcion-error"></span>
      </div>
    </div>

    <div class="form-footer">
      <button class="mt20" onclick="app.userPrivateController.productos.save()">${_data.idcod ? 'Guardar cambios' : 'Crear producto'}</button>
    `;

    if (_data.idcod) {
      html += `
        <button class="mt20 bg-red fr" onclick="app.userPrivateController.productos.delete('${_data.titulo || ''}', '${_data.idcod || ''}')">Eliminar</button>
      `;
    }

    html += `
      <span id="productos-status" class="mt20"></span>
    </div>
    `;

    return html;
  }

  renderItemCollection(_items) {
    let html = '';
    html += '<div class="content items">';

    if (_items.data.length > 0) {
      html = `
        <div class="user-header-content">
          <h1>Mis productos</h1>
          <button onclick="app.userPrivateController.productos.new()">+ Nuevo producto</button>
        </div>
        <div class="content items">
          ${_items.data.map(i => this.renderItem(i)).join('')}
        </div>
        `;
    } else {
      html = `
        <div class="user-header-content">
          <h1>Mis productos</h1>
          <button onclick="app.userPrivateController.productos.new()">+ Nuevo producto</button>
        </div>
        <p> No hay publicaciones, cree su primer producto ahora. </p>
        <br>
        <button onclick="app.userPrivateController.productos.new()">+ Crear mi primer producto</button>
        `;
    }
    return html;
  }

  renderItem(_item) {
    let images = _item.imagenes;
    if (images && typeof images == 'string' && images.length > 0) {
      try {
        images = JSON.parse(images);
      } catch (error) {
        console.log(error, images);
      }
    }
    if (!Array.isArray(images)) {
      images = [];
    }
    return `
    <article>
      <div class="item pb20" onclick="app.userPrivateController.productos.edit('${_item?.idcod}')">
        <img src="${images.length > 0 ? APICRUD.Image.GetUrl(images[0]) : ''}" alt="" onerror="this.src='/assets/img/service.webp'">
        <h1>${_item?.titulo || 'Sin título'}</h1>
        <p>${_item?.resumen || ''}</p>
      </div>
    </article>
  `;
  }

  renderDeleteConfirmation(_title, _idcod) {
    return ` <h2>¿Seguro desea eliminar el producto <b class="cr">${_title}</b>?</h2>
      <button class="bg-red" onclick="app.userPrivateController.productos.deleteConfirmation('${_idcod}')">Eliminar</button>
      <button class="fr" onclick="app.userPrivateController.productos.deleteCancel()">Conservar</button>
      `;
  }
}
